export const IOS_APP_STORE_URL = 'https://apps.apple.com/app/id6755298805';
export const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.olympiq';

/**
 * Picks the store to send a browser visitor of /app/* to. iOS → App Store;
 * Android and desktop → Play Store (per product decision 2026-05-29).
 */
export function storeUrlForUserAgent(userAgent: string): string {
  return /iPhone|iPad|iPod/i.test(userAgent)
    ? IOS_APP_STORE_URL
    : ANDROID_PLAY_STORE_URL;
}

/** Redirects the current browser to the appropriate app store. */
export function redirectToStore(): void {
  window.location.replace(storeUrlForUserAgent(navigator.userAgent));
}
